import type { TracedLayout } from '../traced';

/**
 * Layout measured from a line-drawing plan of a well-known container-yard map (`shipment_layout.png`) by tools/trace-plan.py:
 * `#` wall / container, `.` floor, run-length encoded. Cells are 0.5 m; the play area is 41.9 x 43.4 m.
 * The image itself is not in the repository.
 */
export const SHIPMENT_LAYOUT: TracedLayout = {
  cell: 0.5,
  width: 88,
  height: 91,
  border: 2,
  spawns: [{ x0: 6.0, z0: 4.0, x1: 30.0, z1: 8.4 }, { x0: 58.0, z0: 4.0, x1: 82.0, z1: 8.4 }, { x0: 6.0, z0: 83.4, x1: 30.0, z1: 87.8 }, { x0: 58.0, z0: 83.4, x1: 82.0, z1: 87.8 }],
  sites: [],
  rows: [
    '88#',
    '88#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '2#34.13#37.2#',
    '2#34.13#37.2#',
    '2#34.13#37.2#',
    '2#34.13#37.2#',
    '2#34.13#37.2#',
    '2#34.13#37.2#',
    '2#34.13#37.2#',
    '2#34.13#37.2#',
    '2#34.13#37.2#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '2#29.9#8.9#29.2#',
    '2#29.9#8.9#29.2#',
    '2#29.9#8.9#29.2#',
    '2#29.9#8.9#29.2#',
    '2#29.9#8.9#29.2#',
    '2#29.9#8.9#29.2#',
    '2#29.9#8.9#29.2#',
    '2#11.2#16.9#8.9#29.2#',
    '2#11.4#14.9#8.9#29.2#',
    '2#10.11#8.9#8.9#18.2#9.2#',
    '2#10.11#8.9#8.9#10.11#8.2#',
    '2#10.5#.5#8.9#8.9#10.5#.5#8.2#',
    '2#9.6#.5#44.5#.5#8.2#',
    '2#9.5#2.5#44.5#.5#8.2#',
    '2#8.6#2.5#44.5#.5#8.2#',
    '2#8.5#3.5#44.5#2.5#7.2#',
    '2#7.6#3.5#44.5#2.5#7.2#',
    '2#7.5#4.5#44.5#2.5#7.2#',
    '2#7.5#4.5#44.5#2.5#7.2#',
    '2#9.2#5.5#44.5#2.5#7.2#',
    '2#16.5#8.9#8.9#10.5#3.5#6.2#',
    '2#16.5#8.9#8.9#10.5#3.4#7.2#',
    '2#29.9#8.9#29.2#',
    '2#29.9#8.9#29.2#',
    '2#29.9#8.9#29.2#',
    '2#29.9#8.9#29.2#',
    '2#29.9#8.9#29.2#',
    '2#29.9#8.9#29.2#',
    '2#29.9#8.9#29.2#',
    '2#29.9#8.9#29.2#',
    '2#29.9#8.9#29.2#',
    '2#29.9#8.9#29.2#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '2#35.12#37.2#',
    '2#35.12#37.2#',
    '2#35.12#37.2#',
    '2#35.12#37.2#',
    '2#35.12#37.2#',
    '2#35.12#37.2#',
    '2#35.12#37.2#',
    '2#35.12#37.2#',
    '2#35.12#37.2#',
    '2#35.12#37.2#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '2#84.2#',
    '88#',
    '88#',
  ],
};
